import Calendar from './Calendar'

function Range({ selectedDates, onSelectedDatesChange, isOpen }) {
  const handleDateSelected = ({ selectable, date }) => {
    if (!selectable) {
      return
    }

    let dateTime = date.getTime()
    let newDates = [...selectedDates]

    if (selectedDates.length) {
      if (selectedDates.length === 1) {
        let firstTime = selectedDates[0].getTime()

        if (firstTime < dateTime) {
          newDates.push(date)
        } else {
          newDates = [date]
        }

        onSelectedDatesChange(newDates)
      } else if (newDates.length === 2) {
        onSelectedDatesChange([date])
      }
    } else {
      newDates.push(date)
      onSelectedDatesChange(newDates)
    }
  }

  return (
    <Calendar
      selected={selectedDates}
      onDateSelected={handleDateSelected}
      isOpen={isOpen}
    />
  )
}

export default Range
